/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Saved Searches View Reducer
 */

import { alwaysReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import {
  ALL_NEW_SAVED_SEARCHES_ID,
  ALL_SAVED_SEARCHES_ID,
  BEGIN_REMOVING_SAVED_SEARCH,
  DESELECT_SAVED_SEARCH,
  ERROR_REMOVING_SAVED_SEARCH,
  GET_ALL_COUNT_SUCCESS,
  GET_COUNT_SUCCESS,
  GET_LISTABLES_ERROR,
  GET_LISTABLES_REQUEST,
  GET_LISTABLES_SUCCESS,
  GET_SAVED_SEARCHES_ERROR,
  GET_SAVED_SEARCHES_REQUEST,
  GET_SAVED_SEARCHES_SUCCESS,
  HIDE,
  HIDE_SUMMARY,
  NOT_READY,
  READY,
  RESET_SAVED_SEARCHES_VIEW,
  SELECT_ALL,
  SELECT_ONLY_NEW,
  SELECT_SAVED_SEARCH,
  SET_ALL_FILTERS,
  SET_ANALYTIC_CHANNEL,
  SET_HOVERED,
  SET_IMAGES,
  SET_ONLY_NEW_FILTERS,
  SET_ORIGIN,
  SHOW_SUMMARY,
  SUCCESS_REMOVING,
} from '../constants/index'

import { default as limitReducer } from './limitReducer'
import { default as listablesReducer } from './listablesReducer'
import { default as loadMoreCountReducer } from './loadMoreCountReducer'
import { default as moreResultReducer } from './moreResultReducer'
import { default as offsetReducer } from './offsetReducer'
import { default as savedSearchesReducer } from './savedSearchesReducer'

const savedSearchesViewReducer = combineReducers({
  allCounts: handleActions(
    {
      [GET_ALL_COUNT_SUCCESS]: (state, { payload }) => (payload ? payload.counts : state),
      [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer([]),
    },
    []
  ),
  allFilters: handleActions(
    {
      [SET_ALL_FILTERS]: (state, { payload }) => (payload ? payload.filters : state),
      [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer({}),
    },
    {}
  ),
  analyticChannel: handleActions(
    {
      [SET_ANALYTIC_CHANNEL]: (state, { payload }) =>
        payload ? payload.analyticChannel || '' : state,
      [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer(''),
    },
    ''
  ),
  counts: handleActions(
    {
      [GET_COUNT_SUCCESS]: (state, { payload }) => (payload ? payload.counts : state),
      [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer([]),
    },
    []
  ),
  fetching: handleActions(
    {
      [combineActions(GET_SAVED_SEARCHES_REQUEST, BEGIN_REMOVING_SAVED_SEARCH)]: () => true,
      [combineActions(
        ERROR_REMOVING_SAVED_SEARCH,
        GET_SAVED_SEARCHES_ERROR,
        GET_SAVED_SEARCHES_SUCCESS,
        HIDE,
        RESET_SAVED_SEARCHES_VIEW,
        SUCCESS_REMOVING
      )]: () => false,
    },
    false
  ),
  fetchingListables: handleActions(
    {
      [GET_LISTABLES_REQUEST]: () => true,
      [combineActions(GET_LISTABLES_SUCCESS, GET_LISTABLES_ERROR, HIDE, RESET_SAVED_SEARCHES_VIEW)]:
        () => false,
    },
    false
  ),
  showingSummary: handleActions(
    {
      [SHOW_SUMMARY]: () => true,
      [combineActions(HIDE, HIDE_SUMMARY, RESET_SAVED_SEARCHES_VIEW)]: () => false,
    },
    false
  ),
  hoveredId: handleActions(
    {
      [SET_HOVERED]: (state, { payload }) => (payload ? payload.searchId : state),
      [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer(null),
    },
    null
  ),
  images: handleActions(
    {
      [SET_IMAGES]: (state, { payload }) => (payload ? payload.images : state),
      [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer({}),
    },
    {}
  ),
  limit: limitReducer,
  listables: listablesReducer,
  loadMoreCount: loadMoreCountReducer,
  moreResult: moreResultReducer,
  offset: offsetReducer,
  onlyNewFilters: handleActions(
    {
      [SET_ONLY_NEW_FILTERS]: (state, { payload }) => (payload ? payload.filters : state),
      [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer({}),
    },
    {}
  ),
  origin: handleActions(
    {
      [SET_ORIGIN]: (state, { payload }) => (payload ? payload.origin || '' : state),
      [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer(''),
    },
    ''
  ),
  savedSearches: savedSearchesReducer,
  selectedId: handleActions(
    {
      [SELECT_SAVED_SEARCH]: (state, { payload }) => (payload ? payload.searchId : state),
      [SELECT_ALL]: () => ALL_SAVED_SEARCHES_ID,
      [SELECT_ONLY_NEW]: () => ALL_NEW_SAVED_SEARCHES_ID,
      [combineActions(DESELECT_SAVED_SEARCH, HIDE, RESET_SAVED_SEARCHES_VIEW)]: () => null,
    },
    null
  ),
  ready: handleActions(
    {
      [READY]: () => true,
      [combineActions(HIDE, NOT_READY, RESET_SAVED_SEARCHES_VIEW)]: () => false,
    },
    false
  ),
})

export default savedSearchesViewReducer
